// extracted by mini-css-extract-plugin
module.exports = {"leftSide":"styles_leftSide__rFztC","rightSide":"styles_rightSide__3aLPz","grid":"styles_grid__1PZiq"};